namespace GeniuzPOS.ReportMasterData {
    export class Report_1412Columns {
        static columnsKey = 'ReportMasterData.Report_1412';
    }
}
